import { render, staticRenderFns } from "./invoice-by-id.vue?vue&type=template&id=49770e06&"
import script from "./invoice-by-id.vue?vue&type=script&lang=js&"
export * from "./invoice-by-id.vue?vue&type=script&lang=js&"
import style0 from "./invoice-by-id.vue?vue&type=style&index=0&id=49770e06&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports